import styled from 'styled-components';
import { MultiSelect } from 'ui/selectv2/MultiSelect';
import { MultiSelectInputTheme } from './MultiSelectInputTheme';
import { compactCutOff, delimiter, optionLimit } from './constants';
import { ValueType } from '../../../types';
import { useTranslation } from '../../../../hooks/useTranslation';
import {
  useMultiSelectBaseOptions,
  useMultiSelectErrorMessage,
  useMultiSelectSelectedOptions,
  useUpdateOnSelect,
} from './hooks';

export type Props = {
  valueType: ValueType;
  isReadOnly: boolean;
};

const Container = styled.div`
  display: inline-block;
  width: 100%;
  input[id='queryBuilder-multi-select-input'] {
    box-shadow: none;
  }
`;

export const MultiSelectInput = ({ valueType, isReadOnly }: Props) => {
  const { t } = useTranslation();
  const { options, isLoading } = useMultiSelectBaseOptions(valueType);
  const updateOnSelect = useUpdateOnSelect();
  const selectedOptions = useMultiSelectSelectedOptions();
  const errorMessage = useMultiSelectErrorMessage();
  const createText = t('criteriaField.multiselect.createText');

  return (
    <Container data-test="multi-select-input-container">
      <MultiSelect
        value={selectedOptions}
        options={options}
        onSelect={updateOnSelect}
        optionLimit={optionLimit}
        isLoading={isLoading}
        errorMsg={errorMessage}
        inputId="queryBuilder-multi-select-input"
        id="queryBuilder-multi-select-input"
        compactCutoff={compactCutOff}
        createPrefix={createText}
        pasteDelimiter={delimiter}
        canCreate
        canBulkPaste
        isDisabled={isReadOnly}
        customTheme={MultiSelectInputTheme}
      />
    </Container>
  );
};
